import styled, {
  css,
  DefaultTheme,
  ThemedStyledProps,
} from 'styled-components';
import { getSpacing } from 'utils/spacing';
import { getThemeColor, getThemeTypography } from 'utils/styled';
import { DIVIDER_THICKNESS } from './constants';
import { DividerGutter, DividerStyleProps } from './types';

function getGutterValue(gutter: DividerGutter) {
  if (typeof gutter === 'number') {
    return `${gutter}px`;
  }

  return gutter;
}

function gutterStyle(
  props: ThemedStyledProps<DividerStyleProps, DefaultTheme>,
) {
  const { $gutter } = props;

  const gutterValue = getGutterValue($gutter);

  return `
      margin-left: ${gutterValue};
      margin-right: ${gutterValue};
    `;
}

function getColor(props: ThemedStyledProps<DividerStyleProps, DefaultTheme>) {
  const { $color } = props;

  return $color || getThemeColor('actionTertiary')(props);
}

function getWidth(props: ThemedStyledProps<DividerStyleProps, DefaultTheme>) {
  const { $gutter } = props;

  const gutterTotalExpression = `calc(${getGutterValue($gutter)}) * 2`;
  const width = `calc(100% - ${gutterTotalExpression})`;
  return `
    width: ${width}`;
}

const baseStyle = css<DividerStyleProps>`
  margin: ${getSpacing} 0px;
`;

const noChildrenStyle = css`
  ${baseStyle};
  background-color: ${getColor};
  border: none;
  height: ${DIVIDER_THICKNESS};
`;

const childrenStyle = css`
  ${baseStyle};
  align-items: center;
  color: ${getColor};
  display: flex;
  justify-content: center;

  ${getThemeTypography('h4')};

  &::before,
  &::after {
    background-color: ${getColor};
    content: '';
    height: ${DIVIDER_THICKNESS};
    width: 100%;
  }
`;

export const Root = styled.hr<DividerStyleProps>`
  ${({ hasChildren }) => (hasChildren ? childrenStyle : noChildrenStyle)};
  ${gutterStyle}
  ${(props) => getWidth(props)}
`;

export const ChildContainer = styled.span`
  padding: 0 10px;
`;
